// ─── Base API envelope ────────────────────────────────────────────────────────

export interface ApiResponse<T> {
  success: boolean;
  message: string;
  errors: string[];
  result: T;
}

// ─── KYC status options ───────────────────────────────────────────────────────

export type KycStatus = 'pending' | 'approved' | 'rejected' | 'changes_requested';

export const KYC_STATUS_OPTIONS: { value: KycStatus; label: string }[] = [
  { value: 'approved', label: 'Approved' },
  { value: 'rejected', label: 'Rejected' },
  { value: 'changes_requested', label: 'Changes Requested' },
];

// ─── Provider (list item — from GET /provider/for-admin/get-all) ──────────────

export interface Provider {
  id: string;
  sno: number;
  fullname: string;
  mobile: string;
  address: string;
  aadhar: string;
  pan: string;
  gst: string;
  bankname: string;
  bankaccount: string;
  ifsc: string;
  aadhar_f_img: string | null;
  aadhar_b_img: string | null;
  pan_img: string | null;
  passbook_cheque_img: string | null;
  usertype: string;
  dflag: number;
  cdate: string;
  ctime: string;
  edate: string;
}

// ─── Provider Detail (from GET /provider/admin/:id) ───────────────────────────

export interface ProviderDetail extends Provider {
  isActive: boolean;
  kycStatus: KycStatus | null;
  kycNote: string | null;
}

// ─── API result wrappers ──────────────────────────────────────────────────────

export interface GetAllProvidersResult {
  providers: Provider[];
}

export type GetAllProvidersResponse = ApiResponse<GetAllProvidersResult>;
export type GetProviderByIdResponse = ApiResponse<ProviderDetail>;

// ─── KYC update (PUT /provider/admin/:id/kyc) ─────────────────────────────────

export interface UpdateProviderKycPayload {
  status: KycStatus;
  note?: string | null;
}

export type UpdateProviderKycResponse = ApiResponse<null>;

// ─── Active/Inactive status update (PUT /provider/admin/:id/status) ──────────

export interface UpdateProviderStatusPayload {
  isActive: boolean;
}

export type UpdateProviderStatusResponse = ApiResponse<null>;




// ─── Listing (from GET /provider/listings/admin/:providerId) ─────────────────
export interface ListingAdditionalCharges {
  wallPaintingCharge: number;
  installationCharge: number;
  removalCharge: number;
  otherCharge: number;
  otherChargeDescription: string | null;
}

export interface Listing {
  id: string;
  sno: number;
  providerId: string;
  title: string;
  country: string;
  state: string;
  city: string;
  area: string;
  landmark: string;
  pinCode: string | null;
  latitude: number;
  longitude: number;
  locationTypeId: string | null;
  mediaType: string;
  width: number;
  height: number;
  availableFrom: string;
  availableTo: string;
  expectedRent: number;
  additionalCharges: ListingAdditionalCharges;
  description: string;
  photos: string[];
  dflag: number;
  cdate: string;
  ctime: string;
  edate: string;
}

export interface GetListingsByProviderIdResult {
  listings: Listing[];
}
export type GetListingsByProviderIdResponse = ApiResponse<GetListingsByProviderIdResult>;